import React from 'react';
import trans from 'translate';
import { displayFloats } from '../../../../../../utils/numbersDisplay';
import Tooltip from '../../../../../Common/Tooltip/Tooltip';
import configJson from '../../../../../../config/config.json';
import TxFinder from '../../../../../Common/TxFinder/TxFinder';
import { deductFeeValue, formatNumber, numberWithCommas } from '../../../../../../services/utilsService';
/*eslint-disable */
export const renderedRecords = [
  {
    label: 'hpool.reserved_tickets',
    renderValue: ({ baseTickets, totalTickets }) => `${baseTickets}/${totalTickets}`,
    renderProp: 'reservedTicket',
  },
  {
    label: 'hpool.subscribers',
    renderProp: 'numberOfSubscribers',
  },
  {
    label: 'hpool.total_subscription_amount',
    renderLabel: (label) => <>{trans(label)}</>,
    renderProp: 'totalCapacity',
    renderValue: ({ capacityInUsd, coinTotalCapacity }) => (
      <div className="flex flex-column">
        <span>{[displayFloats(coinTotalCapacity, 3), configJson.baseCoin].join(' ')}</span>
        <span className="disabled">(${displayFloats(capacityInUsd, 3)})</span>
      </div>
    ),
  },
];

export const vpoolRenderedRecords = [
  {
    label: 'Min to participate',
    renderValue: (minParticipationUsd) => `$${numberWithCommas(minParticipationUsd)}`,
    renderProp: 'minParticipationUsd',
  },
  {
    label: 'Max to participate',
    renderValue: (maxParticipationUsd) => `$${numberWithCommas(maxParticipationUsd)}`,
    renderProp: 'maxParticipationUsd',
  },
  {
    label: 'Funds collected',
    renderProp: 'fundsCollected',
    renderValue: (fundsCollected) => `$${numberWithCommas(fundsCollected)}`,
  },
  {
    label: 'Max pool size',
    value: '$500,000',
    renderProp: 'maxPoolAllocationInUsd',
    renderValue: (maxPoolAllocationInUsd) => `$${numberWithCommas(maxPoolAllocationInUsd)}`,
  },
];
